import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';

export interface InvoicePayment {
  paymentId: number;
  invoiceId: number;
  /** Form-only: selected client (not persisted on the payment row). */
  clientId?: number | string;
  paymentDate?: string;
  paymentAmount: number;
  paymentNotes?: string;
  paymentCreatedBy?: number;
  paymentUpdatedBy?: number;
  /** Sum of all payment amounts for this invoice (from detail API). Used for “remaining balance” on edit. */
  invoicePaymentsTotal?: number;
  invoice?: {
    clientId?: number;
    InvoiceNo: string;
    InvoiceDate: string;
    invoiceAmount: number;
    invoiceDescription?: string;
    invoiceTypeDescr?: {
      pst_descr?: string;
      pit_descr?: string;
    };
    invoiceCategoryDescr?: {
      pic_descr?: string;
    };
    client?: {
      clientName?: string;
    };
  };
}

export const useInvoicePayments = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<InvoicePayment[]>(
    `${moduleConfig.module.api.list}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    invoicePayments: data || [], // Keep for backward compatibility
    total: data?.length || 0,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useInvoicePayment = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<InvoicePayment>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    invoicePayment: data, // Keep for backward compatibility
    isLoading,
    isError: error,
    mutate,
  };
};

